import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import DataFetcherTemplate from "../hooks/fetchTemplate";
import BannerGeneral from "../components/BannerGeneral";
import ModalFixed from "../components/ModalFixed";
import Block3Columns from "../components/Block3Columns";
import BlockRightImage from "../components/BlockRightImage";
import BlockLeftImage from "../components/BlockLeftImage";

function Acercade() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <div className=" relative">
              <div>
                {" "}
                <div
                  className="layout8"
                  dangerouslySetInnerHTML={{
                    __html: item.field_texto_portada,
                  }}
                />
                <div className="padding"></div>
              </div>
              <ModalFixed
                title="Conoce nuestra historia 💙"
                content={
                  <>
                    <iframe
                      allowfullscreen=""
                      frameborder="0"
                      height="700"
                      mozallowfullscreen=""
                      src="https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=15c2kS_nfTkn7O4XqbtO6q7sY_tMirfPwyMp1Jb6bcpA&amp;font=Bitter-Raleway&amp;lang=en&amp;initial_zoom=2&amp;height=650"
                      webkitallowfullscreen=""
                      width="100%"
                    ></iframe>
                  </>
                }
                color="#1366a0"
              ></ModalFixed>{" "}
            </div>
            <div className="bluebg padding margin">
              <Block3Columns
                col1={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque1,
                      }}
                    />
                  </>
                }
                col2={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
                col3={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
              ></Block3Columns>
            </div>

            <div
              className="layout8 margin"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque4,
              }}
            />
            <BlockRightImage
              src={item.field_imagen5}
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque5,
                  }}
                />
              }
            ></BlockRightImage>
            <BlockLeftImage
              src={item.field_imagen6}
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque6,
                  }}
                />
              }
            ></BlockLeftImage>
            <div className="relative">
              <BlockRightImage
                src={item.field_imagen7}
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque7,
                    }}
                  />
                }
              ></BlockRightImage>

              <ModalFixed
                title="Historia de conformación de nuestras carreras 🧩"
                content={
                  <>
                    <iframe
                      allowfullscreen=""
                      frameborder="0"
                      height="700"
                      mozallowfullscreen=""
                      src="https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=1j76kXBC5SXwYKugt-oR6MTauJSaf06VlRkQAjCoUHG8&amp;font=Bitter-Raleway&amp;lang=en&amp;initial_zoom=2&amp;height=650"
                      webkitallowfullscreen=""
                      width="100%"
                    ></iframe>
                  </>
                }
                color="#1366a0"
              ></ModalFixed>
            </div>
            <div className="padding2 graybg">
              <div
                className="layout8 margin"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque8,
                }}
              />
              <BlockLeftImage
                src={item.field_imagen9}
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque9,
                    }}
                  />
                }
              ></BlockLeftImage>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      {" "}
      <div className="margin">
        <Breadcumbs
          content={
            <>
              <NavLink to="/acercade">Acerca de</NavLink>
            </>
          }
        ></Breadcumbs>
      </div>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-acercade.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Acercade;
